import {IUserTask} from '@/shared/api-client/models/user-task/user-task';

export type UserTaskStage = 'Preparation' | 'InProgress' | 'Finished';

export class UserTaskStageHelper {

    public static getStage(x: IUserTask): UserTaskStage {

        if (x.entityType === 'ActivityMeeting' || x.entityType === 'ActivityMotion') {

            switch (x.propertyBag.activityStatus) {
                case 'ActivityNotStarted':
                    return 'Preparation';
                case 'ActivityAttendanceControl':
                case 'ActivityInProgress':
                    return 'InProgress';
                case 'ActivityFinished':
                    return 'Finished';
            }

            throw new Error(`Invalid activity status`);
        }

        if (x.entityType === 'Election') {
            switch (x.propertyBag.electionState) {
                case 'ElectionPreparation':
                    return 'Preparation';
                case 'ElectionVoting':
                case 'ElectionNomination':
                    return 'InProgress';
                case 'ElectionFinished':
                    return 'Finished';
            }

            throw new Error(`Invalid election state`);
        }

        throw new Error(`Invalid user task type`);
    }
}
